import { OffersPriceComponent } from '../../offers-price/client/offers-price.component';

export class OffersPriceFeatureComponentComponent extends OffersPriceComponent {}
